<template>

  <v-select
      :prepend-inner-icon="'currency_exchange'"
      :items="items"
      v-model="localValue"
      :label="$t('payment.paymentMethods')"
      :loading="loading"
      :error="hasInputErrors('state')"
      :error-messages="getInputErrors('state')"
      color="secondary"
      item-color="secondary"
      :solo="solo"
      :clearable="clearable"
      :single-line="singleLine"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
      :multiple="multiple"
  ></v-select>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


export default {
  name: "PaymentMethodsCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    dense: {type: Boolean, default: false},
    clearable: {type: Boolean, default: false},
    multiple: {type: Boolean, default: false},
    solo: {type: Boolean, default: false},
    singleLine: {type: Boolean, default: false},
    outlined: {type: Boolean, default: false},
    hideDetails: {type: Boolean, default: false},
  },
  data() {
    return {
      paymentMethods: [],
      loading: false,
      items: [
        {text: 'Efectivo', value:'CASH'},
        {text: 'Débito', value:'DEBIT'},
        {text: 'Transferencia Bancaria', value:'BANK_TRANSFER'},
        {text: 'Mercado Pago', value:'MP_TRANSFER'},
        {text: 'Rappi', value:'RAPPI'},
        {text: 'Pedidos Ya', value:'PEDIDOS_YA'},
      ]
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input',val)
      }
    },
  },

}
</script>

<style scoped>

</style>

